import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Button,
  Flex,
  Link,
  Text,
} from '@chakra-ui/react';

interface DeactivatePassModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeactivatePassModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: DeactivatePassModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
    <ModalOverlay />
    <ModalContent borderRadius="10px" py="30px" px="49px">
      <ModalCloseButton top="16px" right="16px" />
      <Text textStyle="headingFamilyMedium" fontSize="24px" textAlign="center">
        Deactivate this pass?
      </Text>
      <Text
        textStyle="bodyFamilyRegular"
        fontSize="16px"
        color="black"
        mt="32px"
        lineHeight="1.8"
      >
        Deactivating moves this pass to the holder's archived passes. It will no
        longer work at entry points.
      </Text>
      <Text
        textStyle="bodyFamilyRegular"
        fontSize="16px"
        color="black"
        mt="16px"
        lineHeight="1.8"
      >
        You can reactivate it at any time, but the holder will need to manually
        restore it from their archived passes.
      </Text>
      <Flex mt="32px" justify="center" align="center" gap={4}>
        <Link
          textStyle="bodyFamilyBold"
          fontSize="14px"
          color="inkBlue"
          textDecoration="underline"
          onClick={onClose}
          cursor="pointer"
          px="17px"
          py="13px"
          textUnderlineOffset="3px"
        >
          Cancel
        </Link>
        <Button
          variant="outlineDanger"
          size="sm"
          px="17px"
          py="13px"
          borderRadius="5px"
          onClick={onConfirm}
          isLoading={isLoading}
        >
          Deactivate
        </Button>
      </Flex>
    </ModalContent>
  </Modal>
);

export default DeactivatePassModal;
